import { tw } from "@careinfo/tailwind";
import loadable from "@loadable/component";
const SalesComponent = loadable(() => import("../../components/Sales"));
const Sales = () => {
  return (
    <>
      <div className={tw`flex items-center justify-between`}>
        <h1 className={tw`font-semibold text-2xl leading-8`}>Sales</h1>
      </div>
      <SalesComponent />
    </>
  );
};

export default Sales;
